import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../material.module';
import { CharitylistreportComponent } from './charitylistreport/charitylistreport.component';

@Component({
  selector: 'app-reports',
  imports: [TablerIconsModule, MaterialModule, CharitylistreportComponent, RouterModule],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {


  constructor(private router: Router,) { }


  openCharityList() {
    this.router.navigate(['/reports/charitylistreport']);
  }
  openTrusteeList() {
    this.router.navigate(['/reports/trusteelistreport']);
  }
  openTrailBalance() {
    this.router.navigate(['/reports/trialreport']);
  }
  openChartofAccountsReport() {
    this.router.navigate(['/reports/chartofaccountsreport']);
  }
}
